import React from 'react';
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';
const cardSx = {
    borderRadius: '8px',
    boxShadow: 'none',
    border: '1px solid #E5E7EB',
    bgcolor: '#fff',
};
const SummaryCardSkeleton = () => (React.createElement(Card, { sx: cardSx },
    React.createElement(CardContent, { sx: { p: 2, '&:last-child': { pb: 2 } } },
        React.createElement(Skeleton, { variant: "text", width: "50%", sx: { fontSize: 12 } }),
        React.createElement(Skeleton, { variant: "text", width: "70%", sx: { fontSize: 26, mt: 0.5 } }))));
const RowSkeleton = () => (React.createElement(Card, { sx: cardSx },
    React.createElement(CardContent, { sx: { p: 2, '&:last-child': { pb: 2 } } },
        React.createElement(Stack, { direction: "row", spacing: 3, alignItems: "center" },
            React.createElement(Skeleton, { variant: "rounded", width: 36, height: 36 }),
            React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                React.createElement(Skeleton, { variant: "text", width: "35%", sx: { fontSize: 14 } }),
                React.createElement(Skeleton, { variant: "text", width: "55%", sx: { fontSize: 12 } })),
            React.createElement(Skeleton, { variant: "rounded", width: 90, height: 28 })))));
const RouteLoadingSkeleton = () => (React.createElement(Box, { sx: { p: 3 } },
    React.createElement(Skeleton, { variant: "text", width: 220, sx: { fontSize: 22, mb: 2 } }),
    React.createElement(Box, { sx: {
            display: 'grid',
            gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
            gap: 2,
            mb: 3,
        } },
        React.createElement(SummaryCardSkeleton, null),
        React.createElement(SummaryCardSkeleton, null),
        React.createElement(SummaryCardSkeleton, null),
        React.createElement(SummaryCardSkeleton, null)),
    React.createElement(Stack, { spacing: 1.5 },
        React.createElement(RowSkeleton, null),
        React.createElement(RowSkeleton, null),
        React.createElement(RowSkeleton, null))));
export default RouteLoadingSkeleton;
